<template>
    <div class="kefu_v">
        <div class="loading-container">
            <div class="loading-spinner"></div>
        </div>
    </div>
</template>

<script>

    import Fetch from '../../utils/fetch'

    export default {
        name: "index",
        components: {},
        data() {
            return {
                data: {},
				userInfo: null, // 存储用户信息
                jumpTimer: null
            };
        },
        created() {
            this.$parent.footer('user');
        },
        mounted() {
            // 检查是否从客服页面返回
            const referrer = document.referrer;
            const isFromKefuPage = referrer && referrer.includes('/kf/');
            
            console.log('访问来源检测:', { 
                referrer, 
                isFromKefuPage,
                currentUrl: window.location.href 
            });
            
            // 如果从客服页面(/kf/)返回，直接跳转到首页
            if (isFromKefuPage) {
                console.log('检测到从客服页面返回，跳转到首页');
                this.$router.push('/');
            } else {
                // 正常访问客服页面
                console.log('正常访问客服页面');
                this.start();
            }
        },
        beforeDestroy() {
            // 清理定时器
            if (this.jumpTimer) {
                clearTimeout(this.jumpTimer);
            }
        },
        methods: {
            start() {
                // 防止重复调用
                if (this.jumpTimer) {
                    this.$router.push('/');
                }
                
                let agent = localStorage.getItem('agent');
                Fetch('/index/webconfig', {agent,type: 'web'}).then(res => {
                    // 直接跳转到客服链接
                    if (res.data.kefu_link) {
                        console.log('跳转到客服:', res.data.kefu_link);
                        // 稍微延迟跳转，确保页面状态稳定
                        this.jumpTimer = setTimeout(() => {
                            window.location.href = res.data.kefu_link;
                        }, 300);
                    }
                }).catch(err => {
                    console.error('获取客服配置失败:', err);
                    this.$toast('客服配置加载失败，请稍后重试');
                    // 加载失败时返回首页
                    this.jumpTimer = setTimeout(() => {
                        this.$router.push('/');
                    }, 2000);
                })
            },
			// 获取用户信息
			async getUserInfo() {
			    try {
			        this.loading = true;
			        console.log('开始获取用户信息...');
			        
			        // 检查是否有token，没有token则不请求用户信息
			        const token = localStorage.getItem('token');
			        if (!token) {
			            console.log('没有token');
			            // this.$router.replace('/login');
			            return;
			        }
			        
			        // 调用API获取用户信息
			        const result = await Fetch('/user/info');
			        
			        console.log('用户信息API响应:', result);
			        
			        if (result && result.code === 1) {
			            console.log('用户信息获取成功:', result.data);
			            this.userInfo = result.data;
			            // 将用户信息保存到全局store中
			            this.$store.commit('setUserInfo', result.data);
			        } else if (result && result.code === 0) {
			            console.log('用户信息业务提示:', result);
			            // 显示业务提示信息
			            let message = '';
			            if (typeof result.info === 'string') {
			                message = result.info;
			            } else if (typeof result.info === 'object') {
			                const currentLang = localStorage.getItem('lang') || 'zh_hk';
			                message = result.info[currentLang] || result.info.zh_cn || '获取用户信息失败';
			            }
			            console.log('提示信息:', message);
			        } else {
			            console.error('用户信息获取失败:', result);
			        }
			    } catch (error) {
			        console.error('获取用户信息出错:', error);
			    } finally {
			        this.loading = false;
			    }
			},
            
        }
    };
</script>

<style lang="less" scoped>

    .kefu_v {
        position: fixed;
        width: 100%;
        height: 100%;
        max-width: 750px;
        -webkit-overflow-scrolling: touch;
        overflow-y: scroll;
        background-color: #fff;
        
        .loading-container {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            
            .loading-spinner {
                width: 40px;
                height: 40px;
                border: 4px solid #f3f3f3;
                border-top: 4px solid #1989fa;
                border-radius: 50%;
                animation: spin 1s linear infinite;
            }
        }
        
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        
    }
</style>


